<template>
  <li>
    <div class="w-full campaign-banner" v-if="booking.campaign">
      <div><i class="fa fa-lg fa-clone margin-r-1"></i> Part of campaign: {{ booking.campaign.name }}</div>
      <router-link class="margin-r-1" v-if="$userIsAdmin" :to="{ name: 'campaign.edit', params: { id: booking.campaign.id }}">
        <span>View Campaign <i class="fa fa-chevron-right"></i></span>
      </router-link>
    </div>
    <div class="list-item">
      <router-link :to="link" class="list-item__container">
        <div class="list-item__content">
          <div class="list-item__header">
            <div class="list-item__pills">
              <slot name="pill"></slot>
            </div>
            <div class="list-item__title" data-test-id="hasTitle">
              <slot name="title">
                <h3>{{ bookingName }}</h3>
              </slot>
            </div>
            <slot name="bids"></slot>
            <div class="list-item__category">
              <slot name="categories"></slot>
            </div>
          </div>
          <div class="list-item__meta list-meta">
            <div class="list-item__status w-full">
              <slot name="status"></slot>
            </div>
            <meta-item icon="map-marker" :label="false">
              {{ bookingStateOrOnline | nullable }}
            </meta-item>
            <meta-date
              v-if="bookingAppearanceInPerson"
              :booking="booking"
              icon="calendar"
            />
            <meta-due
              v-if="bookingAppearanceOnline"
              :booking="booking"
              icon="globe"
            />
            <meta-offer-date
              v-if="bookingAppearanceOffer"
              :booking="booking"
              icon="calendar"
            />
            <slot name="meta"></slot>
            <slot name="client">
              <meta-item v-if="$userIsManager" :is-name="true" icon="user" :label="false">
                {{ bookingTalentNames }}
              </meta-item>
              <meta-item v-else-if="$userIsNotClient && bookingClientCompanyAndName" :is-name="true" icon="user" :label="false">
                {{ bookingClientCompanyAndName }}
              </meta-item>
            </slot>
            <div v-if="$userIsAdmin && booking.latest_note && booking.latest_note.text" class="w-full flex justify-end spacer-t-2">
              <div class="comment spacer-t-2">
                <div class="comment__body" v-html="booking.latest_note.text"></div>
                <div class="comment__meta">
                  <div class="comment__author">{{ booking.latest_note.user.name }}</div>
                  <div class="comment__date">{{ latestNoteDateCreated | date($user.date_format_preference) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list-item__values">
          <div class="list-item__hero" v-if="$slots.hero" >
            <slot name="hero"></slot>
          </div>
          <div v-if="!$userIsAdmin" class="list-item__admin">
            <slot name="admin"></slot>
          </div>
          <div v-if="$userIsAdmin" class="list-item__admin">
            <slot name="admin"></slot>
            <meta-item data-test-id="requestDate">
              <template v-slot:key>Created:</template>
              {{ bookingDateCreated | date($user.date_format_preference) }}
            </meta-item>
            <meta-item data-test-id="requestID">
              <template v-slot:key>Request ID:</template>
              {{ this.booking.id }}
            </meta-item>
            <template v-if="!$vlastMode">
              <div class="spacer-y-1"></div>
              <meta-item data-test-id="conversionProbability">
                <template v-slot:key>Conversion Probability:</template>
                {{ this.booking.conversion_probability | nullable }}
              </meta-item>
              <meta-item data-test-id="pipelineStatus">
                <template v-slot:key>Pipeline Status:</template>
                {{ this.booking.pipeline_status | sentenceCase | nullable }}
              </meta-item>
              <meta-item data-test-id="estCloseDate">
                <template v-slot:key>Est. Close Date:</template>
                {{ this.booking.est_close_date | dateTimezone(this.$user.timezone) | nullable }}
              </meta-item>
            </template>
            <meta-item data-test-id="assignedAdmin">
              <template v-slot:key>Admin:</template>
              {{ bookingAssignedAdmin }}
            </meta-item>
          </div>
          <div v-else-if="$userIsManager" class="list-item__admin">
            <meta-item data-test-id="requestID">
              <template v-slot:key>Request ID:</template>
              {{ this.booking.id }}
            </meta-item>
          </div>
        </div>
      </router-link>
    </div>
  </li>
</template>

<script>
import { helpers } from 'mixins/bookings'
import moment from 'moment-timezone'
import MetaItem from './meta/MetaItem'
import MetaDate from './meta/MetaDate'
import MetaDue from './meta/MetaDue'
import MetaOfferDate from './meta/MetaOfferDate'

export default {
  mixins: [helpers],
  components: {
    MetaOfferDate,
    MetaItem,
    MetaDate,
    MetaDue
  },
  props: {
    booking: {
      type: Object,
      required: true
    },
    link: {
      type: Object,
      required: true
    },
    price: {
      type: String,
      default: null
    }
  },
  computed: {
    bookingDateCreated () {
      return moment.utc(this.booking.created_at).local()
    },
    /**
     * Show latest note date created in local time
     */
    latestNoteDateCreated () {
      return moment.utc(this.booking.latest_note.created_at).local()
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-banner {
  border-left: 8px solid #e3e3e3;
  padding: 10px;
  background-color: #e4e4e7;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  color: #1d1d1d;
  a {
    color: #1d1d1d;
  }
}
</style>
